import { RESET_STATE } from 'store/global/actions';

import { COMPANY_FORM_FIELD_DATA_ACTION_TYPE } from '../actions';

const initialState = {};

const updateCompanyTrustees = (state, companyId, getNextTrustees) => {
  const companyData = state[companyId];

  if (!companyData) {
    return state;
  }

  return {
    ...state,
    [companyId]: {
      ...companyData,
      trustees: getNextTrustees(companyData.trustees || []),
    },
  };
};

const formFieldDataReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COMPANY_FORM_FIELD_DATA_ACTION_TYPE.GET_FORM_FIELD_DATA:
      return { ...state, ...payload };

    case COMPANY_FORM_FIELD_DATA_ACTION_TYPE.EDIT_FORM_FIELD_DATA:
      return {
        ...state,
        [payload.companyId]: {
          ...payload,
          trustees: payload.trustees ?? state[payload.companyId]?.trustees ?? [],
        },
      };

    case COMPANY_FORM_FIELD_DATA_ACTION_TYPE.CREATE_TRUSTEE:
      return updateCompanyTrustees(state, payload.companyId, trustees => [
        ...trustees,
        payload.trustee,
      ]);

    case COMPANY_FORM_FIELD_DATA_ACTION_TYPE.EDIT_TRUSTEE:
      return updateCompanyTrustees(state, payload.companyId, trustees =>
        trustees.map(trustee => (trustee.id === payload.trustee.id ? payload.trustee : trustee)),
      );

    case COMPANY_FORM_FIELD_DATA_ACTION_TYPE.DELETE_TRUSTEE:
      return updateCompanyTrustees(state, payload.companyId, trustees =>
        trustees.filter(trustee => trustee.id !== payload.trusteeId),
      );

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default formFieldDataReducer;
